module.exports = __webpack_public_path__ + "img/medshelf.f8cab577.jpg";